import { get, post, remove } from './api';
import routes from './end-points';

export const adminPaymentDocumentApi = {
  list: (date) => post(routes.admin.paymentDocument.list, date),
  initUserFund: (userFundId) => get(routes.admin.paymentDocument.initUserFund(userFundId)),
  setDepositorStatus: (depositorId, statusId) =>
    post(routes.admin.paymentDocument.setDepositorStatus, { statusId, PaymentDocumentsDepositorId: depositorId }),
  initUserPaymentHistories: (userId) => get(routes.admin.paymentDocument.initUserPaymentHistories(userId)),
  initCreate: () => get(routes.admin.paymentDocument.initCreate),
  deleteDepositor: (id) => remove(routes.admin.paymentDocument.deleteDepositor(id)),
  suggestDeptors: (data) => post(routes.admin.paymentDocument.suggestDeptors, data),
  saveChanges: (dto) => post(routes.admin.paymentDocument.saveChanges, dto),
  sendForBankAccount: (id) => get(routes.admin.paymentDocument.sendForBankAccount(id)),
  closePaymentDocument: (id) => get(routes.admin.paymentDocument.closePaymentDocument(id)),
  goBackStatus: (id) => get(routes.admin.paymentDocument.goBackStatus(id)),
};
